"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Survey = void 0;
var _InnerPopupWrapperStyled = require("../../InnerPopupWrapper/InnerPopupWrapperStyled");
var _Button = _interopRequireDefault(require("../../Button"));
var _popupSlice = require("../../../redux/popupSlice");
var _reactI18next = require("react-i18next");
var _store = require("../../../redux/store");
var _planHelper = require("../../../util/planHelper");
var _UpdateSubscriptionStyled = require("../UpdateSubscriptionStyled");
var _Checkbox = _interopRequireDefault(require("../../Checkbox"));
var _Loader = _interopRequireDefault(require("../../Loader"));
var _offersSlice = require("../../../redux/offersSlice");
var _utils = require("../utils");
var _unsubscribeSlice = require("../../../redux/unsubscribeSlice");
var _Unsubscribe = _interopRequireDefault(require("../Unsubscribe.enum"));
var _jsxRuntime = require("react/jsx-runtime");
const Survey = _ref => {
  var _offers$find;
  let {
    scheduledSwitch,
    customCancellationReasons,
    checkedReason,
    shouldShowDowngrades,
    shouldShowFreeExtension,
    setCurrentStep,
    handleCheckboxClick,
    handleUnsubscribe
  } = _ref;
  const offerDetails = (0, _store.useAppSelector)(_popupSlice.selectOfferData);
  const dispatch = (0, _store.useAppDispatch)();
  const {
    offers
  } = (0, _store.useAppSelector)(_offersSlice.selectOffers);
  const {
    loading: isLoading
  } = (0, _store.useAppSelector)(_unsubscribeSlice.selectUnsubscribe);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const formattedExpiresAt = (0, _planHelper.dateFormat)(Number(offerDetails === null || offerDetails === void 0 ? void 0 : offerDetails.expiresAt));
  const scheduledResult = scheduledSwitch();
  const cancelUnsubscribeAction = () => {
    window.dispatchEvent(new CustomEvent('MSSDK:unsubscribe-action-cancelled'));
    dispatch((0, _popupSlice.hidePopup)());
  };
  const toOfferId = scheduledResult !== false ? scheduledResult.toOfferId : null;
  const toOfferIdTitle = (_offers$find = offers.find(_ref2 => {
    let {
      longId
    } = _ref2;
    return longId === toOfferId;
  })) === null || _offers$find === void 0 ? void 0 : _offers$find.title;
  const scheduledSwitchTitle = t("offer-title-".concat(toOfferId), toOfferIdTitle);
  const translatedTitle = t("offer-title-".concat(offerDetails === null || offerDetails === void 0 ? void 0 : offerDetails.offerId), offerDetails ? offerDetails.offerTitle : '');
  const cancellationReasonsToShow = customCancellationReasons !== null && customCancellationReasons !== void 0 && customCancellationReasons.length ? customCancellationReasons : _utils.defaultCancellationReasons;
  const handleGoBackButton = () => {
    if (shouldShowFreeExtension) {
      setCurrentStep(_Unsubscribe.default.FREE_EXTENSION);
      return;
    }
    if (shouldShowDowngrades) {
      setCurrentStep(_Unsubscribe.default.DOWNGRADES);
      return;
    }
    cancelUnsubscribeAction();
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ContentStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TitleStyled, {
        children: t('unsubscribe-popup.survey-title', 'We’re sorry to see you go')
      }), (offerDetails === null || offerDetails === void 0 ? void 0 : offerDetails.period) === 'season' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
        children: t('unsubscribe-popup.survey.access-info', 'You will keep access to your seasonal subscription until {{formattedExpiresAt}}. Before you go, please let us know why you’re leaving.', {
          formattedExpiresAt: (offerDetails === null || offerDetails === void 0 ? void 0 : offerDetails.expiresAt) === _planHelper.INFINITE_DATE ? t('unsubscribe-popup.next-season-start', 'the next season start') : (0, _planHelper.dateFormat)(offerDetails === null || offerDetails === void 0 ? void 0 : offerDetails.expiresAt)
        })
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.TextStyled, {
        children: [scheduledSwitch() ? t('unsubscribe-popup.survey.switch-pending', "Your subscription switch is still pending. You will switch to {{scheduledSwitchTitle}} and be charged a new price.", {
          scheduledSwitchTitle
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: offerDetails !== null && offerDetails !== void 0 && offerDetails.inTrial ? t('unsubscribe-popup.survey.free-trial', 'Your {{translatedTitle}} free trial will end on {{formattedExpiresAt}}.', {
            translatedTitle,
            formattedExpiresAt
          }) : t('unsubscribe-popup.survey.subscription-paid', 'Your {{translatedTitle}} subscription is paid until {{formattedExpiresAt}}.', {
            translatedTitle,
            formattedExpiresAt
          })
        }), ' ', /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactI18next.Trans, {
          i18nKey: "unsubscribe-popup.survey.info",
          children: ["If you would like to proceed with cancelling your subscription, please select \u2018Unsubscribe\u2019 below, and your subscription will be cancelled as of ", {
            formattedExpiresAt
          }, ". Until then, you will continue to have access to all of your current subscription features. Before you go, please let us know why you're leaving."]
        })]
      }), cancellationReasonsToShow && /*#__PURE__*/(0, _jsxRuntime.jsx)(_UpdateSubscriptionStyled.ReasonsWrapper, {
        children: cancellationReasonsToShow.map(_ref3 => {
          let {
            key,
            value
          } = _ref3;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_UpdateSubscriptionStyled.StyledItem, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.default, {
              isRadioButton: true,
              onClickFn: () => handleCheckboxClick(value),
              checked: value === checkedReason,
              children: t(key, value)
            })
          }, key);
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ButtonWrapperStyled, {
      $removeMargin: true,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        theme: "simple",
        onClickFn: handleGoBackButton,
        children: t('unsubscribe-popup.survey.go-back', 'Go back')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        theme: "confirm",
        onClickFn: handleUnsubscribe,
        disabled: checkedReason === '' || isLoading,
        children: isLoading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
          buttonLoader: true,
          color: "#ffffff"
        }) || t('unsubscribe-popup.survey.unsubscribe', 'Unsubscribe')
      })]
    })]
  });
};

// eslint-disable-next-line import/prefer-default-export
exports.Survey = Survey;